import CountryData from '../components/data/CountryCodes.json';
import CurrencyData from '../components/data/currencies.json';

export const getCountries = () => 
  CountryData.map(({ name, dial_code, code, currency }) => ({
    name,
    dial_code,
    code, // Ensure country code is included
    currency, // Include currency if needed later
  }));

export const getCurrencies = () => 
  CurrencyData.map(({ code, name }) => ({
    code,
    name
  }));
